import {
  type BankAccount,
  type CompleteBankRefundInput,
  completeBankRefundInputSchema,
} from '@repo/api-contracts';
import { useId, useState } from 'react';
import { formStyles, Input, Label, OrderActionDialog } from '@/shared/ui';

interface Props {
  readonly orderId: string;
  readonly refundAccount: BankAccount | null;
  readonly today: string;
  readonly onSubmit: (input: CompleteBankRefundInput) => Promise<void>;
  readonly onReload: () => void;
  readonly onClose: () => void;
  readonly pending?: boolean;
}
export function CompleteBankRefundDialog({
  orderId,
  refundAccount,
  today,
  onSubmit,
  onReload,
  onClose,
  pending,
}: Props) {
  const id = useId();
  const [date, setDate] = useState(today);
  const [bank, setBank] = useState(refundAccount?.bank ?? '');
  const [account, setAccount] = useState(refundAccount?.account ?? '');
  const [holder, setHolder] = useState(refundAccount?.holder ?? '');
  const [memo, setMemo] = useState('');
  const input = { orderId, refundedOn: date, refundAccount: { bank, account, holder }, memo };
  return (
    <OrderActionDialog
      title="환불 완료"
      submitLabel="환불 완료"
      onReload={onReload}
      onClose={onClose}
      pending={pending}
      validate={() =>
        completeBankRefundInputSchema.safeParse(input).success
          ? null
          : '송금일과 환불 계좌를 확인해 주세요.'
      }
      onSubmit={async () => {
        await onSubmit(input);
        return '환불이 완료되었습니다.';
      }}
    >
      <div className={formStyles.field}>
        <Label htmlFor={`${id}-date`}>송금일</Label>
        <Input
          id={`${id}-date`}
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </div>
      <div className={formStyles.field}>
        <Label htmlFor={`${id}-bank`}>은행</Label>
        <Input id={`${id}-bank`} value={bank} onChange={(e) => setBank(e.target.value)} />
      </div>
      <div className={formStyles.field}>
        <Label htmlFor={`${id}-account`}>계좌번호</Label>
        <Input id={`${id}-account`} value={account} onChange={(e) => setAccount(e.target.value)} />
      </div>
      <div className={formStyles.field}>
        <Label htmlFor={`${id}-holder`}>예금주</Label>
        <Input id={`${id}-holder`} value={holder} onChange={(e) => setHolder(e.target.value)} />
      </div>
      <div className={formStyles.field}>
        <Label htmlFor={`${id}-memo`}>메모</Label>
        <Input id={`${id}-memo`} value={memo} onChange={(e) => setMemo(e.target.value)} />
      </div>
    </OrderActionDialog>
  );
}
